/*
使用方法：
1.main.js中注册
import {
  UseShowTipsToast,
  UseCloseTipsToast
} from './components/common/tips-toast/index'
Vue.use(UseShowTipsToast) ////挂到原型链上  提示信息弹窗的组件
Vue.use(UseCloseTipsToast)


2,直接使用  
type:弹窗类型, 可在tips-toast.VUE中添加和查看具体支持的类型
objData弹窗要显示的数据 , 
ifAutoHiding =false：弹窗是否要自动隐藏（可不填默认不自动隐藏） 
autoHidingTime=1000，弹窗自动隐藏的时间（弹窗自动隐藏设置后，生效  默认1S）
this.$showTips1Toast(type, objData , ifAutoHiding = false,autoHidingTime=1000)

3，主动关闭弹窗
this.$closeTipsToast()
*/
import Vue from 'vue'


// 这里就是我们刚刚创建的那个静态组件
import tipsToast from './tips1-toast.vue'



// 返回一个 扩展实例构造器
const ToastConstructor = Vue.extend(tipsToast)
let toastDom = null
let autoHideTimer = null
let destroyTimer = null
function disposeToast(instance) {
  if (!instance) return
  instance.$destroy()
  if (instance.$el && instance.$el.parentNode) instance.$el.parentNode.removeChild(instance.$el)
}
// 定义弹出组件的函数 接收4个参数
function showTips1Toast(type, objData , ifAutoHiding = false, autoHidingTime=1000 ,index = 0) {
  clearTimeout(autoHideTimer)
  clearTimeout(destroyTimer)
  disposeToast(toastDom)
  toastDom = null
  // 实例化一个 toast.Vue
  console.log(toastDom)
  toastDom = new ToastConstructor({
    el: document.createElement('div'),
    data() {
      return {
        toastState:{ ///淡入淡出的控制
          click: true,
          fade: true,        
        },
        type:type,
        objData:objData,
        ifAutoHiding:ifAutoHiding,
        autoHidingTime:autoHidingTime,
        index:index

        // showWrap: true, // 是否显示组件
        // showContent: true // 作用:在隐藏组件之前,显示隐藏动画
      }
    }
  })

  // 把 实例化的 toast.Vue 添加到 body 里
  document.body.appendChild(toastDom.$el)
  console.log(toastDom)
    /// 根据传入的参数控制确定是否自动隐藏
  if (ifAutoHiding) {
    const instance = toastDom
    autoHideTimer = setTimeout(() => {
      if (toastDom === instance) closeTips1ToastDom()
    }, autoHidingTime)
  }
}

function closeTips1ToastDom() {
  if (!toastDom) return
  clearTimeout(autoHideTimer)
  clearTimeout(destroyTimer)
  const instance = toastDom
  instance.toastState.fade = false
  destroyTimer = setTimeout(() => {
    disposeToast(instance)
    if (toastDom === instance) toastDom = null
  }, 400)
}

// 注册为全局组件的函数
function UseShowTips1Toast() {
  // 将组件注册到 Vue 的 原型链里去,
  // 这样就可以在所有 Vue 的实例里面使用 this.$toast()
  Vue.prototype.$showTips1Toast = showTips1Toast  ///控制显示toast的函数
}
function UseCloseTips1Toast() {
    // 将组件注册到 Vue 的 原型链里去,
  Vue.prototype.$closeTips1Toast = closeTips1ToastDom  ///////////控制关闭toast的的函数
}

export { UseShowTips1Toast, UseCloseTips1Toast }
